import React, { useEffect, useState } from 'react';
import QRLib, { QRCodeToDataURLOptions } from 'qrcode';
interface IProps {
  /**koden som ska visas */
  qrCode?: string;
  /** bredd på bilden i pixlar, ignoreras om koden är för lång för att kunna kodas i den aktuella bredden*/
  width?: number;
}
/**
 * Visar en QR-kod
 * Se https://www.npmjs.com/package/qrcode för mer info om kodningen
 */
export const EDQRCode: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const [qrImage, setQrImage] = useState<string>();

  useEffect(() => {
    const options: QRCodeToDataURLOptions = {
      width: props.width ?? 200,
      margin: 3,
      errorCorrectionLevel: 'medium',
    };
    QRLib.toDataURL(props.qrCode ?? '', options)
      .then(url => {
        setQrImage(url);
      })
      .catch(() => {
        setQrImage(undefined);
      });
  }, [props.qrCode, props.width]);

  if (!qrImage) {
    return null;
  }

  return <img src={qrImage} alt="QR-kod" />;
};
